// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBalanceHistoryCloseDto
 */
export interface IBalanceHistoryCloseDto {
    /**
     * 
     * @type {number}
     * @memberof IBalanceHistoryCloseDto
     */
    our_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceHistoryCloseDto
     */
    bank_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceHistoryCloseDto
     */
    difference?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceHistoryCloseDto
     */
    prior?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceHistoryCloseDto
     */
    delta?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceHistoryCloseDto
     */
    credit?: number;
    /**
     * 
     * @type {number}
     * @memberof IBalanceHistoryCloseDto
     */
    debit?: number;
    /**
     * 
     * @type {string}
     * @memberof IBalanceHistoryCloseDto
     */
    close_date?: string;
}

/**
 * Check if a given object implements the IBalanceHistoryCloseDto interface.
 */
export function instanceOfIBalanceHistoryCloseDto(value: object): value is IBalanceHistoryCloseDto {
    return true;
}

export function IBalanceHistoryCloseDtoFromJSON(json: any): IBalanceHistoryCloseDto {
    return IBalanceHistoryCloseDtoFromJSONTyped(json, false);
}

export function IBalanceHistoryCloseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBalanceHistoryCloseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'our_balance': json['our_balance'] == null ? undefined : json['our_balance'],
        'bank_balance': json['bank_balance'] == null ? undefined : json['bank_balance'],
        'difference': json['difference'] == null ? undefined : json['difference'],
        'prior': json['prior'] == null ? undefined : json['prior'],
        'delta': json['delta'] == null ? undefined : json['delta'],
        'credit': json['credit'] == null ? undefined : json['credit'],
        'debit': json['debit'] == null ? undefined : json['debit'],
        'close_date': json['close_date'] == null ? undefined : json['close_date'],
    };
}

export function IBalanceHistoryCloseDtoToJSON(json: any): IBalanceHistoryCloseDto {
    return IBalanceHistoryCloseDtoToJSONTyped(json, false);
}

export function IBalanceHistoryCloseDtoToJSONTyped(value?: IBalanceHistoryCloseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'our_balance': value['our_balance'],
        'bank_balance': value['bank_balance'],
        'difference': value['difference'],
        'prior': value['prior'],
        'delta': value['delta'],
        'credit': value['credit'],
        'debit': value['debit'],
        'close_date': value['close_date'],
    };
}

